import * as product from '@/store/modules/product.js'
import * as filter from '@/store/modules/claim/filter.js'
import * as journal from '@/store/modules/claim/journal.js'
import * as search from '@/store/modules/search.js'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { DataService } from '@/services/DataService.js'
// import _ from 'lodash'
const moment = extendMoment(Moment)

export const namespaced = true

export const modules = {
  product,
  filter,
  journal,
  search
}

export const state = {
  statuses: [
    { id: 0, code: 'draft', name: 'Формируется' },
    { id: 1, code: 'formed', name: 'Сформирована' },
    { id: 2, code: 'approved', name: 'Утверждена' },
    { id: 3, code: 'done', name: 'Исполнена' },
    { id: 4, code: 'done', name: 'Удалена' }
  ],
  managers: [],
  departments: [],
  priorities: [
    // { id: 0, code: 'normal', name: 'Нормальный' }, // нормальная т.е. не аварийная
    { id: 1, code: 'high', name: 'Высокий' } // Аварийная
  ],
  claims: [],
  stats: {}
}

export const getters = {
  priorities (state) {
    return state.priorities
  },
  statuses (state) {
    return state.statuses
  },
  status (state) {
    return (id) => {
      return state.statuses.find((p) => {
        return p.id === id
      })
    }
  },
  stats (state) {
    return state.stats
  },
  managers (state, getters, rootState, rootGetters) {
    return rootGetters['companyInfo/managers']
  },
  manager (state, getters, rootState, rootGetters) {
    return rootGetters['companyInfo/manager']
  },
  departments (state, getters, rootState, rootGetters) {
    return rootGetters['companyInfo/departments']
  },
  claims (state) {
    return state.claims
  },
  filteredClaims (state, getters) {
    return getters.claims
  },
  searchResult (state) {
    return state.searchResult
  },
  apiParams: (state, getters, rootState, rootGetters) => page => {
    const format = 'YYYY-MM-DD'
    const dr = getters['filter/dateRange'] || {}
    let params = {
      companyId: rootGetters['user/user']?.companyId,
      critical: getters['filter/priority'][0],
      employeeId: getters['filter/manager'],
      departmentId: getters['filter/department'],
      states: getters['filter/status'].length ? getters['filter/status'].map(String) : undefined,
      from: dr.start ? moment(dr.start).format(format) : undefined,
      to: dr.start ? moment(dr.end).format(format) : undefined,
      offset: (page - 1) * 10,
      limit: 10
    }
    params = Object.entries(params).filter(([k, v]) => v !== null && v !== undefined)
    return Object.fromEntries(params)
  },
  totalCount (state, getters) {
    const statuses = Object.values(getters['filter/status'])
    const stats = state.stats
    let counts = 0
    if (statuses.length) {
      counts = statuses.map(s => stats[s])
    } else {
      counts = Object.values(stats)
    }
    const total = counts.filter(v => v).reduce((acc, v) => acc + v, 0)
    return total % 10 ? Math.floor(total / 10) + 1 : total / 10
  },
  makeClaim (state, getters) {
    return ({ claims }) => {
      const statuses = Object.fromEntries(getters.statuses?.map(status => ([status.name, status])) || [])
      return mapBackendClaimsToFrontend(claims, statuses)
    }
  }
}

export const mutations = {
  SET_CLAIMS (state, data = []) {
    state.claims = data
  },
  SET_MANAGERS (state, data = []) {
    state.managers = data
  },
  SET_DEPARTMETS (state, data = []) {
    state.departments = data
  },
  UPDATE_CLAIM (state, { id, positions, comments }) {
    const claim = state.claims.find(claim => claim.id === id)
    claim.comments = comments
    claim.order_items = positions
  },
  SET_CLAIMS_STATS (state, data) {
    state.stats = data
  }
}

async function loadClaims (params, commit, statuses) {
  const { data } = await DataService.getClaims(params)

  const claims = mapBackendClaimsToFrontend(data.claims, statuses)
  commit('SET_CLAIMS', claims)
}

export const actions = {
  async load ({ commit, getters, dispatch }, page) {
    dispatch('loadStatusStats')

    const params = getters.apiParams(page)
    const statuses = Object.fromEntries(getters.statuses?.map(status => ([status.name, status])) || [])
    await loadClaims(params, commit, statuses)
  },
  async loadStatusStats ({ commit, getters }) {
    const params = [{
      key: 'departmentId',
      value: getters['filter/department']
    }, {
      key: 'employeeId',
      value: getters['filter/manager']
    }, {
      key: 'critical',
      value: getters['filter/priority'].length
    }, {
      key: 'from',
      value: getters['filter/dateRange']?.start
    }, {
      key: 'to',
      value: getters['filter/dateRange']?.end
    }].reduce((acc, p) => {
      if (p.value) {
        acc[p.key] = p.value
      }
      return acc
    }, {})

    const stats = await DataService.getClaimsStats(params)

    // Костыль. Для заявок не существует справочника статусов в старой системе,
    // поэтому в ответе от сервера группа - это не идентификатор статуса, а его название
    const rawClaimsStats = stats.data.claims_stats.reduce(function (map, obj) {
      map[obj.group] = obj.count
      return map
    }, {})

    // TODO: Статусы по заявкам должны отдаваться с бэкенда
    const claimsStats = {
      0: rawClaimsStats['Формируется'] || 0,
      1: rawClaimsStats['Сформирована'] || 0,
      2: rawClaimsStats['Утверждена'] || 0,
      3: rawClaimsStats['Исполнена'] || 0,
      4: rawClaimsStats['Удалена'] || 0
    }

    commit('SET_CLAIMS_STATS', claimsStats)
  }
}

function mapBackendClaimsToFrontend (claims, statuses) {
  return claims?.map(claim => (
    {
      id: claim.id,
      title: claim.name, // наименование заявки
      status_id: statuses[claim.state]?.id || 0, // статус
      manager_id: claim.userId, // менеджер
      manager_name: claim.userName,
      department_id: claim.departmentId, // отдел
      department_name: claim.departmentName,
      datetime_created: claim.createDate, // дата перехода в статус Формирование (создана)
      datetime_formed: null, // дата перехода в статус Сформирована
      datetime_approved: null, // дата перехода в статус Утверждена
      datetime_done: claim.finishedDate, // дата перехода в статус Исполнена
      datetime_deleted: null, // дата перехода в статус Удалена
      datetime_delivery: claim.finishedDate, // дата поставки
      limit: null, // лимит по заявке
      expense: claim.billDirection, // направление затрат (статья расходов), пример: 'хознужды' или 'плановый ремонт'
      priority_id: claim.critical,
      status_history: [
        {
          datetime: claim.createDate,
          status_id: 0,
          manager_id: claim.userId,
          manager_name: claim.userName,
          department_id: claim.departmentId,
          department_name: claim.departmentName
        },
        {
          datetime: claim.finishedDate,
          status_id: 3,
          manager_id: claim.userId,
          manager_name: claim.userName,
          department_id: claim.departmentId,
          department_name: claim.departmentName
        }
      ].filter(st => st.datetime)
      // order_items: [{
      //   sequence_no: 1,
      //   product_id: 235249,
      //   ordered: { count: 1, summary: null },
      //   approved: { count: 1, summary: 40000 }
      // }, {
      //   sequence_no: 2,
      //   product_id: 235244,
      //   ordered: { count: 1, summary: null },
      //   approved: { count: 1, summary: 35000 }
      // }],
      // status_history: [{
      //   status_id: 0,
      //   manager_id: 0,
      //   department_id: 0,
      //   datetime: '2020-05-11T10:00:00Z'
      // }, {
      //   status_id: 1,
      //   manager_id: 1,
      //   department_id: 1,
      //   datetime: '2020-05-18T18:10:00Z'
      // }, {
      //   status_id: 2,
      //   manager_id: 2,
      //   department_id: 2,
      //   datetime: '2020-05-20T17:00:00Z'
      // }],
      // comments: [{
      //   id: 0,
      //   manager_id: 1,
      //   comment: 'Успели вовремя',
      //   datetime: '2020-05-20T17:00:00Z'
      // }]
    }
  ))
}
